import { useParams } from "react-router";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { PricingCards } from "@/services/backend/rlt/pricing/components/pricing-cards";

export function WorkOrderPlanningPricingRoute() {
  const { workOrderId } = useParams();
  const { data } = useRltWorkOrderShowQuery({ id: workOrderId! });

  return <PricingCards pricingId={data!.pricingId} />;
}
